import EditBillingPeriodFormDto from 'types/PrpTable/dto/EditBillingPeriodFormDto';

const EditBillingPeriodDefaultValue = (id: number): EditBillingPeriodFormDto => ({
  id,
  amount: null
});

export default EditBillingPeriodDefaultValue;
